import { render, staticRenderFns } from "./ZDMCatalogsTab.vue?vue&type=template&id=70b0cd6c&scoped=true&"
import script from "./ZDMCatalogsTab.vue?vue&type=script&lang=js&"
export * from "./ZDMCatalogsTab.vue?vue&type=script&lang=js&"
import style0 from "./ZDMCatalogsTab.vue?vue&type=style&index=0&id=70b0cd6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0cd6c",
  null
  
)

export default component.exports